// extracted by mini-css-extract-plugin
export var paginationCurrent = "index-module--pagination-current--aa403";
export var thumbsSwiper = "index-module--thumbs-swiper--44ac4";